import { type RefObject, useEffect } from 'react';

const isInside = (
  sheetRef: RefObject<HTMLElement | null>,
  target: EventTarget | null,
) => target instanceof Node && !!sheetRef.current?.contains(target);

/**
 * Close challenger mobile bottom sheets when the user scrolls or interacts
 * outside the drawer (Funnel-Feedback booking summary mobile behavior).
 */
export function useCloseMobileDrawerOnOutsideInteraction(
  isOpen: boolean,
  sheetRef: RefObject<HTMLElement | null>,
  onClose: () => void,
) {
  useEffect(() => {
    if (!isOpen) return;

    const closeIfOutside = (event: Event) => {
      if (!isInside(sheetRef, event.target)) {
        onClose();
      }
    };

    document.addEventListener('scroll', closeIfOutside, true);
    document.addEventListener('wheel', closeIfOutside, {
      capture: true,
      passive: true,
    });
    document.addEventListener('touchmove', closeIfOutside, {
      capture: true,
      passive: true,
    });
    document.addEventListener('pointerdown', closeIfOutside, true);

    return () => {
      document.removeEventListener('scroll', closeIfOutside, true);
      document.removeEventListener('wheel', closeIfOutside, true);
      document.removeEventListener('touchmove', closeIfOutside, true);
      document.removeEventListener('pointerdown', closeIfOutside, true);
    };
  }, [isOpen, onClose, sheetRef]);
}
